// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__1poe4","read-only":"styles_read-only__3i1yD","disabled":"styles_disabled__32bFl"};